import BaseApi from './BaseApi';
import { clearAuthSession, getRefreshToken, setAuthSession, updateStoredUser } from './authStorage';

class AuthService extends BaseApi {
  constructor() {
    super('/auth');
  }

  async login(payload) {
    const session = await this.post('/login', payload);
    setAuthSession(session);
    return session;
  }

  async logout() {
    const refreshToken = getRefreshToken();
    try {
      if (refreshToken) {
        await this.post('/logout', { refreshToken });
      }
    } finally {
      clearAuthSession();
    }
  }

  async updateProfile(payload) {
    const user = await this.client.put('/profile', payload);
    updateStoredUser(user);
    return user;
  }

  getDarkMode() {
    return this.get('/dark-mode');
  }

  updateDarkMode(darkMode) {
    return this.put('/dark-mode', { darkMode });
  }

  changePassword(payload) {
    return this.post('/change-password', payload);
  }
}

export default new AuthService();
